import styles from './Content.module.scss';

// isEditorPage - pages that are full screen pages where we are editing data (e.g. community or assessment link
export const Content = ({ isEditorPage, children }) => {
  return (
    <div className={isEditorPage ? styles.editorContent : styles.content}>{children}</div>
  );
};
